const autoNgTemplateLoaderTemplate1 = require('./customer-meal-time-tab.template.html');

'use strict';

angular
    .module('app')
    .directive('customerMealTimeTab', customerMealTimeTab);

customerMealTimeTab.$inject = [];

function customerMealTimeTab() {
    return {
        restrict: 'E',
        templateUrl: autoNgTemplateLoaderTemplate1,
        controller: 'CustomerMealTimeTabController',
        controllerAs: 'vm',
        scope: {}
    };
}
